import React from 'react'
import './TasksField.css'
import Task from '../Task/Task'

function TasksField({tasks}) {
  
  return (
    <ul className="tasks-field">
        {tasks.map((task) => (
          <Task 
            key={task.id}
            task={task}
          />
        ))}
    </ul>
  );
}

export default TasksField;